import React from "react";
import { Grid } from "@material-ui/core";
import LineChart from "components/LineChart";
import { useDispatch, useSelector } from "react-redux";
import { getReportDateSelector } from "redux/user/user";
import { RootState } from "redux/rootReducer";
import { loadYieldHistories } from "redux/yieldHistory/yieldHistoryFunctions";
import { useTranslation } from "react-i18next";
import { VisibleSections } from "types/VisibleSections";

const YieldHistory = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const reportControlId = useSelector(
    (state: RootState) => state.user.reportControlId
  );
  const reportDate = useSelector(getReportDateSelector);

  const yieldHistory = useSelector(
    (state: RootState) => state.yieldHistory.all?.data ?? []
  );
  const yieldHistoryLoading = useSelector(
    (state: RootState) => state.yieldHistory.all?.loading
  );

  const showIndex = useSelector(
    (state: RootState) =>
      (state.user.visibleSections?.data as VisibleSections | undefined)
        ?.NaytaTuotto ?? false
  );

  React.useEffect(() => {
    if (reportControlId && reportDate) {
      dispatch(loadYieldHistories(reportControlId, reportDate, showIndex));
    }
  }, [dispatch, reportControlId, reportDate, showIndex]);

  return (
    <Grid item md={6} sm={12} style={{ position: "relative" }}>
      <h3 style={{ color: "#444443", marginTop: 0 }}>{t("yield_history")}</h3>
      <LineChart
        data={yieldHistory}
        index={showIndex}
        loading={yieldHistoryLoading}
      />
    </Grid>
  );
};

export default React.memo(YieldHistory);
